<template>
  <div>
     <Header1></Header1>
    
  </div>
</template>

<script>
import Header1 from "@/components/Header1.vue";
export default {
 components: {
    Header1,
  },
}
</script>

<style>

</style>